export type IncorporationItemForGraph = {
  sharesCount: number;
  stakeholder?: { fullName: string; id: string } | null;
};

export type AggregatedIncorporationStakeholder = {
  consideredPay: number;
  id: string;
  name: string;
  percentage: number;
  shares: number;
  value: number;
};

export const aggregateIncorporationStakeholders = ({
  items,
  parValue,
  sharesDivider = 1,
}: {
  items: IncorporationItemForGraph[];
  parValue: number;
  sharesDivider?: number;
}): {
  stakeholders: AggregatedIncorporationStakeholder[];
  totalConsideredPay: number;
  totalIssuedShares: number;
} => {
  const totalIssuedShares = items.reduce((sum, item) => sum + (item.sharesCount || 0), 0);
  const byStakeholderId = new Map<string, AggregatedIncorporationStakeholder>();

  for (const item of items) {
    if (!item.stakeholder?.id) continue;

    const shares = item.sharesCount || 0;
    const consideredPay = shares * parValue;
    const existing = byStakeholderId.get(item.stakeholder.id);

    if (existing) {
      existing.shares += shares;
      existing.consideredPay += consideredPay;
      existing.percentage = totalIssuedShares > 0 ? (existing.shares * 100) / totalIssuedShares : 0;
      continue;
    }

    byStakeholderId.set(item.stakeholder.id, {
      id: item.stakeholder.id,
      name: item.stakeholder.fullName,
      shares,
      percentage: totalIssuedShares > 0 ? (shares * 100) / totalIssuedShares : 0,
      value: 0,
      consideredPay,
    });
  }

  const stakeholders = Array.from(byStakeholderId.values()).map((stakeholder) => ({
    ...stakeholder,
    shares: stakeholder.shares / sharesDivider,
  }));

  return {
    stakeholders,
    totalIssuedShares,
    totalConsideredPay: totalIssuedShares * parValue,
  };
};
